import React, { useState } from 'react';
import { useData } from '../contexts/DataContext';
import { FaPlus, FaSearch, FaTrash, FaEye, FaUserMd, FaPhone, FaEnvelope, FaMapMarkerAlt, FaTimes, FaShareAlt, FaCopy, FaCheck, FaWhatsapp } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import '../styles/Clients.css';

const Clients = () => {
    const { clients, addClient, deleteClient } = useData();
    const navigate = useNavigate();
    const [showForm, setShowForm] = useState(false);
    const [newClient, setNewClient] = useState({ name: '', email: '', phone: '', address: '' });
    const [searchTerm, setSearchTerm] = useState('');
    const [inviteModal, setInviteModal] = useState(null);
    const [copied, setCopied] = useState(false);

    const getInviteLink = (clientId) => {
        const baseUrl = window.location.origin;
        return `${baseUrl}/register?ide=${clientId.substr(0, 8)}`;
    };

    const handleInvite = (client) => {
        setInviteModal(client);
        setCopied(false);
    };

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    };

    const getInviteMessage = (client) => {
        const link = getInviteLink(client.id);
        return `Bonjour ${client.name},\n\nVous êtes invité(e) à créer votre espace client sur ENOVADENT.\n\nVotre identifiant client (IDE) : ${client.id.substr(0, 8)}\n\nCliquez sur ce lien pour créer votre compte :\n${link}\n\nCordialement,\nLaboratoire Enovadent`;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        addClient(newClient);
        setNewClient({ name: '', email: '', phone: '', address: '' });
        setShowForm(false);
    };

    const filteredClients = clients.filter(client =>
        client.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const getInitials = (name) => {
        return name ? name.substring(0, 2).toUpperCase() : 'DR';
    };

    return (
        <div className="clients-page container-fluid px-0">
            {/* Header */}
            <div className="page-header d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center gap-3">
                    <div className="bg-primary text-white p-3 rounded-circle shadow-sm">
                        <FaUserMd size={24} />
                    </div>
                    <div>
                        <h2 className="mb-0">Mes Praticiens</h2>
                        <span className="text-muted small">{clients.length} partenaire(s) enregistré(s)</span>
                    </div>
                </div>
                <button
                    className={`btn-add-client ${showForm ? 'bg-danger' : ''}`}
                    onClick={() => setShowForm(!showForm)}
                >
                    {showForm ? <><FaTimes className="me-2" /> Annuler</> : <><FaPlus className="me-2" /> Nouveau Praticien</>}
                </button>
            </div>

            {/* Form Section */}
            {showForm && (
                <div className="form-card mb-4 animate__animated animate__fadeInDown">
                    <div className="form-header">
                        <FaPlus className="me-2 text-primary" /> Ajouter un nouveau partenaire
                    </div>
                    <div className="card-body p-4">
                        <form onSubmit={handleSubmit}>
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <label className="form-label fw-bold small text-muted">Nom du Cabinet / Praticien</label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-light"><FaUserMd /></span>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Ex: Dr. Dupont"
                                            required
                                            value={newClient.name}
                                            onChange={e => setNewClient({ ...newClient, name: e.target.value })}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label fw-bold small text-muted">Email</label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-light"><FaEnvelope /></span>
                                        <input
                                            type="email"
                                            className="form-control"
                                            placeholder="contact@cabinet.com"
                                            value={newClient.email}
                                            onChange={e => setNewClient({ ...newClient, email: e.target.value })}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label fw-bold small text-muted">Téléphone</label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-light"><FaPhone /></span>
                                        <input
                                            type="tel"
                                            className="form-control"
                                            placeholder="01 23 45 67 89"
                                            value={newClient.phone}
                                            onChange={e => setNewClient({ ...newClient, phone: e.target.value })}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label fw-bold small text-muted">Adresse</label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-light"><FaMapMarkerAlt /></span>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Adresse complète..."
                                            value={newClient.address}
                                            onChange={e => setNewClient({ ...newClient, address: e.target.value })}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="d-flex justify-content-end mt-4">
                                <button type="submit" className="btn btn-success px-5 fw-bold shadow-sm">
                                    Enregistrer le Praticien
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* Search */}
            <div className="search-container position-relative">
                <FaSearch className="search-icon" />
                <input
                    type="text"
                    className="search-input"
                    placeholder="Rechercher un praticien par nom..."
                    value={searchTerm}
                    onChange={e => setSearchTerm(e.target.value)}
                />
            </div>

            {/* Modern Table / List */}
            <div className="clients-grid">
                <div className="client-row header d-none d-md-grid">
                    <div>Praticien</div>
                    <div>Contact</div>
                    <div>Adresse</div>
                    <div className="text-end">Actions</div>
                </div>

                {filteredClients.length === 0 ? (
                    <div className="text-center py-5 text-muted">
                        <FaUserMd size={48} className="mb-3 text-light-gray" />
                        <p>Aucun praticien trouvé.</p>
                    </div>
                ) : (
                    filteredClients.map(client => (
                        <div
                            className="client-row"
                            key={client.id}
                            onClick={() => navigate(`/clients/${client.id}`)}
                            title={`Ouvrir le dossier de ${client.name}`}
                        >
                            {/* Name & Avatar */}
                            <div className="client-name">
                                <div className="client-avatar">
                                    {getInitials(client.name)}
                                </div>
                                <div>
                                    {client.name}
                                    <small className="d-block text-muted fw-normal" style={{ fontSize: '0.8rem' }}>
                                        ID: {client.id.substr(0, 8)}
                                    </small>
                                </div>
                            </div>

                            {/* Contact Info */}
                            <div className="client-info">
                                {client.email && <span className="client-email"><FaEnvelope className="me-2 text-primary" size={12} />{client.email}</span>}
                                {client.phone && <span className="client-phone mt-1"><FaPhone className="me-2 text-success" size={12} />{client.phone}</span>}
                                {!client.email && !client.phone && <span className="text-muted small">-</span>}
                            </div>

                            {/* Address */}
                            <div className="client-address text-truncate">
                                {client.address ? (
                                    <span><FaMapMarkerAlt className="me-2 text-danger" size={14} />{client.address}</span>
                                ) : <span className="text-muted small">Non renseignée</span>}
                            </div>

                            {/* Actions */}
                            <div className="text-end" onClick={e => e.stopPropagation()}>
                                <button
                                    className="btn-action-invite"
                                    onClick={(e) => { e.stopPropagation(); handleInvite(client); }}
                                    title="Inviter ce client"
                                >
                                    <FaShareAlt className="me-1" />
                                    Inviter
                                </button>
                                <button
                                    className="btn-action-view"
                                    onClick={(e) => { e.stopPropagation(); navigate(`/clients/${client.id}`); }}
                                >
                                    <FaEye className="me-2" />
                                    Dossier
                                </button>
                                <button
                                    className="btn-action-delete"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        if (window.confirm('Voulez-vous vraiment supprimer ce praticien ?')) {
                                            deleteClient(client.id);
                                        }
                                    }}
                                    title="Supprimer"
                                >
                                    <FaTrash />
                                </button>
                            </div>
                        </div>
                    ))
                )}
            </div>

            {/* Invite Modal */}
            {inviteModal && (
                <div className="invite-overlay" onClick={() => setInviteModal(null)}>
                    <div className="invite-modal" onClick={(e) => e.stopPropagation()}>
                        <button className="invite-modal-close" onClick={() => setInviteModal(null)}>
                            <FaTimes />
                        </button>
                        <div className="invite-modal-header">
                            <FaShareAlt className="invite-modal-icon" />
                            <h3>Inviter {inviteModal.name}</h3>
                            <p>Partagez ce lien pour que votre client puisse créer son espace</p>
                        </div>

                        <div className="invite-modal-body">
                            <div className="invite-ide-box">
                                <span className="invite-ide-label">Identifiant Client (IDE)</span>
                                <span className="invite-ide-value">{inviteModal.id.substr(0, 8)}</span>
                            </div>

                            <div className="invite-link-box">
                                <span className="invite-link-label">Lien d'inscription</span>
                                <div className="invite-link-row">
                                    <input
                                        type="text"
                                        readOnly
                                        value={getInviteLink(inviteModal.id)}
                                        className="invite-link-input"
                                    />
                                    <button
                                        className={`invite-copy-btn ${copied ? 'copied' : ''}`}
                                        onClick={() => copyToClipboard(getInviteLink(inviteModal.id))}
                                    >
                                        {copied ? <><FaCheck /> Copié !</> : <><FaCopy /> Copier</>}
                                    </button>
                                </div>
                            </div>

                            <div className="invite-actions">
                                <button
                                    className="invite-action-btn invite-whatsapp"
                                    onClick={() => {
                                        const msg = encodeURIComponent(getInviteMessage(inviteModal));
                                        window.open(`https://wa.me/${inviteModal.phone ? inviteModal.phone.replace(/[^0-9+]/g, '') : ''}?text=${msg}`, '_blank');
                                    }}
                                >
                                    <FaWhatsapp /> Envoyer par WhatsApp
                                </button>
                                <button
                                    className="invite-action-btn invite-email"
                                    onClick={() => {
                                        const subject = encodeURIComponent('Votre espace client ENOVADENT');
                                        const body = encodeURIComponent(getInviteMessage(inviteModal));
                                        window.open(`mailto:${inviteModal.email || ''}?subject=${subject}&body=${body}`, '_blank');
                                    }}
                                >
                                    <FaEnvelope /> Envoyer par Email
                                </button>
                                <button
                                    className="invite-action-btn invite-copy-msg"
                                    onClick={() => copyToClipboard(getInviteMessage(inviteModal))}
                                >
                                    <FaCopy /> Copier le message complet
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Clients;
